import { render, staticRenderFns } from "./PopUpBannersCreate.vue?vue&type=template&id=2736108d&scoped=true"
import script from "./PopUpBannersCreate.vue?vue&type=script&lang=js"
export * from "./PopUpBannersCreate.vue?vue&type=script&lang=js"
import style0 from "./PopUpBannersCreate.vue?vue&type=style&index=0&id=2736108d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2736108d",
  null
  
)

export default component.exports